import Blazy from "blazy";
import {addBLazyContainer, initMainHeader} from '../js/src/header-init';
import Tab from '../js/src/tabs';
import {addThirdPartyLoad, Utils} from "../js/src/utils";
import carouselInit from "../js/src/carousel";
import {getQuoteFormInit, scrollToQuoteForm} from "../js/src/get-quote-form";
import {initVideo} from "../js/src/video-player";
import '../scss/pages/product.scss';

initMainHeader();
global.openTab = Tab.open.bind(Tab);
// global.openStickyTab = Tab.openStickyMobile.bind(Tab);
global.scrollToQuoteForm = scrollToQuoteForm;

Tab.init();

carouselInit(8000);
addThirdPartyLoad(() => {
    Tab.initStickyTabs('#bottom-content');
    getQuoteFormInit()
    initVideo();
    addBLazyContainer('.lazy-container');


    if (document.getElementById('conf-list-box')) {
        new Blazy({
            container: '#conf-list-box'
        })
    }

    (() => {
        const parent = document.getElementById('conf-list-container');

        if (!parent) {
            return
        }

        window.addEventListener('resize', init);
        init();

        function init() {
            const prevBtn = parent.querySelector('.prev');
            const nextBtn = parent.querySelector('.next');
            const scrollBox = parent.querySelector('.conf-list-box');

            if (scrollBox.scrollWidth < scrollBox.offsetWidth || Utils.isMobile()) {
                nextBtn.style.display = 'none';
                prevBtn.style.display = 'none';
                return;
            }

            prevBtn.onclick = navClick.bind(null, -1);
            nextBtn.onclick = navClick.bind(null, 1);

            function navClick(dir) {
                const itemBox = scrollBox.querySelector('.item-box')
                const itemWidth = Utils.outerWidth(itemBox);
                const blockCount = Math.floor(scrollBox.offsetWidth / itemWidth);
                const left = scrollBox.scrollLeft + (itemWidth * blockCount * dir);

                scrollBox.scrollTo({left: left, behavior: 'smooth'});
            }
        }
    })();
});
